export var capitaliseFirstLetter = function capitaliseFirstLetter(text) {
  return "".concat(text.charAt(0).toUpperCase()).concat(text.slice(1));
};